import { PopupRequest, PublicClientApplication } from '@azure/msal-browser';
import axios from 'axios';

type B2CConfiguration = {
    authorityB2C: string;
    authorityAD: string;
    authorityADChangeEmailFlow: string;
    authorityDomain: string;
    clientId: string;
    scopes: string;
};

type SPAConfiguration = {
    backendUserServiceUrl: string;
    userServiceAppUrl: string;
    paymentsServiceAppUrl: string;
    backendReportsInternalServiceURL: string;
    backendReportsAiServiceUrl: string;
    notificationsServiceAppUrl: string;
    pushServerPublicKey: string;
    appInsightsConnectionString: string;
    backendPaymentsServiceUrl: string;
    underMaintenanceFileUrl: string;
    backendNotificationsServiceUrl: string;
    b2c: B2CConfiguration;
};

//Patched Holder to replace Hooks to Redux store, this is initail setup to be optimized later
export class MSALHolder {
    private static instance: MSALHolder | null = null;

    private static configuration: SPAConfiguration | null = null;

    private static initPromise: Promise<MSALHolder> | null = null;

    public static getInstance = (): Promise<MSALHolder> => {
        if (MSALHolder.instance != null) {
            return Promise.resolve(MSALHolder.instance);
        }

        if (MSALHolder.initPromise != null) {
            return MSALHolder.initPromise;
        }

        MSALHolder.initPromise = (async () => {
            try {
                const response =
                    await axios.get<SPAConfiguration>(`/config.json`);
                MSALHolder.configuration = response.data;
            } catch (e) {
                /* empty */
            }
            MSALHolder.instance = new MSALHolder();
            return MSALHolder.instance;
        })();

        return MSALHolder.initPromise;
    };

    getLoginRequest = (): PopupRequest => {
        return {
            scopes: [MSALHolder.configuration?.b2c.scopes!]
        };
    };

    getLoginRequestAD = (): PopupRequest => {
        return {
            scopes: [MSALHolder.configuration?.b2c.scopes!],
            authority: MSALHolder.configuration!.b2c.authorityAD
        };
    };

    getSpaConfiguration = () => {
        const config = MSALHolder.configuration;
        return config;
    };

    public static msalInstance: PublicClientApplication | null = null;
}
